import { Container } from '@pixi/display';
import { Sprite } from '@pixi/sprite';
import { Text } from '@pixi/text';

import { Shared } from '../App';

export class UserIdentity extends Container
{
    private content: Container;
    private flag: Sprite;
    private nick: Text;

    constructor()
    {
        super();

        this.content = new Container();
        this.addChild(this.content);

        this.flag = new Sprite();
        this.flag.anchor.set(0, 0.5);
        this.flag.texture = Shared.assets.getTexture('flag-allstar-1');
        this.content.addChild(this.flag);

        this.nick = new Text('AAA', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            align: 'left',
            fontSize: 50,
            stroke: 0x333333,
            strokeThickness: 10,
            lineJoin: 'round',
        });
        this.nick.y = -1;
        this.nick.anchor.set(0, 0.5);
        this.content.addChild(this.nick);
    }

    public refresh(): void
    {
        this.nick.text = Shared.user.getNickname();
        this.flag.texture = Shared.assets.getTexture(`flag-${Shared.user.getFlag()}`);
        this.flag.x = this.nick.width + 2;
        this.content.x = -this.content.width / 2;
    }
}
